// extracted by mini-css-extract-plugin
export default {"charityIcon":"CharityIcon_charityIcon__uWDDZ"};